module.exports = __webpack_public_path__ + "141d4a85/img/pwrd-by-sourcery-black.bba9ba41.svg";